// extracted by mini-css-extract-plugin
export var backdrop = "HeaderSearchDropdown-module--backdrop--UtmjW";
export var component = "HeaderSearchDropdown-module--component--gPsch";
export var dropdown = "HeaderSearchDropdown-module--dropdown--1GUmw";
export var input = "HeaderSearchDropdown-module--input--6qRlm";
export var inputWrapper = "HeaderSearchDropdown-module--inputWrapper--cI3KY";
export var label = "HeaderSearchDropdown-module--label--LLefC";
export var searchIcon = "HeaderSearchDropdown-module--searchIcon--qnyRW";
export var spinner = "HeaderSearchDropdown-module--spinner--GpX05";
export var toggler = "HeaderSearchDropdown-module--toggler---U4Ki";